import React from 'react';
import {connect} from "react-redux";
import {Nav} from "react-bootstrap";

function Navi(props) {
    return <Nav className={`Navi py-4 ${(props.hasOwnProperty('className')) ? props.className : ''}`}>
            {props.children}
           </Nav>
}

const mapStateToProps = (store) => {
    return {};
};

export default connect(mapStateToProps)(Navi);